import Button from '@material-ui/core/Button';
import SendIcon from '@material-ui/icons/Send';
import { useContext } from 'react';
import { useForm } from 'react-hook-form';
import { reSubmitTask } from '../../../api/task';
import { ApiContext } from '../../../contexts/ApiContext';
import { AuthContext } from '../../../contexts/AuthContext';
import { SnackbarAlert, useSnackBar } from '../../Common/SnackBarContext';
import { InputField } from '../Form';

const MultiTextFieldTask = ({ task }) => {
  const parsedParam = task;
  const { handleSubmit, errors, register } = useForm({
    mode: 'onBlur',
  });
  const snackBarHelper = useSnackBar();

  const apiContext = useContext(ApiContext);
  const authContext = useContext(AuthContext);

  const onSubmit = async (data) => {
    snackBarHelper.openSnackBar('info', 'Mengirim...');
    try {
      const sub = await reSubmitTask(
        apiContext.axios,
        data,
        task?.id,
        authContext?.surat.id
      );
      if (sub) {
        snackBarHelper.openSnackBar('success', 'Permintaan dikirim');
      }
    } catch (err) {
      snackBarHelper.openSnackBar('error', err.toString());
    }
  };

  return (
    <>
      <h2 className={''}>{task?.name}</h2>

      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="mt-3">
          {parsedParam?.widget_parameters?.data?.map((data, i) => (
            <InputField
              key={i}
              type={data.type}
              attr={data.attr}
              rules={data.rules}
              register={register}
              error={errors[data.attr]}
            />
          ))}
        </div>
        <div id="status" className="mt-3"></div>
        <div id="simpan" className="mt-4">
          <Button
            type="submit"
            variant="contained"
            color="primary"
            startIcon={<SendIcon />}
          >
            Submit
          </Button>
        </div>
      </form>
      <SnackbarAlert />
    </>
  );
};

export default MultiTextFieldTask;
